import type { ChangeEvent } from "react";

export function setDateAndDismiss(event: ChangeEvent<HTMLInputElement>, setDate: (value: string) => void) {
  setDate(event.currentTarget.value);
  event.currentTarget.blur();
}
